import { render } from "./CurrentDealer.vue?vue&type=template&id=3438975e&scoped=true"
import script from "./CurrentDealer.vue?vue&type=script&lang=js"
export * from "./CurrentDealer.vue?vue&type=script&lang=js"

import "./CurrentDealer.vue?vue&type=style&index=0&id=3438975e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3438975e"]])

export default __exports__